import { getSessionId, logAndThrowHttpError } from '@sky-distribution/gp-onboarding-monitoring';
import axios, { AxiosInstance } from 'axios';
import { API_BASE_URL, PathApi, SESSION_ID_HEADER_NAME } from '../config/config';
import { GetEngineerDataResponse } from '../service/getEngineerDataResponseSchema';

const api = (): AxiosInstance => axios.create({
  baseURL: API_BASE_URL,
  headers: {
    [SESSION_ID_HEADER_NAME]: getSessionId(),
  },
});

export const apiGetEngineerData = async (
  token: string,
): Promise<GetEngineerDataResponse> => {
  const { data } = await api()
    .get<GetEngineerDataResponse>(`${PathApi.ENGINEER_DATA}?token=${token}`)
    .catch(logAndThrowHttpError<GetEngineerDataResponse>('getEngineerData', token));

  return data;
};
